import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllPlaces } from "../api/getAllPlaces";
import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";

// All your logic is here
export const usePlacesDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "",selectedRows: [],});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetPlace[]>([]);
  const getAllPlacesQuery = useGetAllPlaces({data: submitedFilters ? submitedFilters : {},});
  const { t } = useTranslation();

  const loadingDone = [getAllPlacesQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getAllPlacesQuery].filter(({ isError }) =>isError ? true : false);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getAllPlacesQuery.data ? getAllPlacesQuery.data : [];

  const columnData = [
    {
      columnName: "name",
      columnDisplayName: "Τοποθεσία",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "address",
      columnDisplayName: "Διεύθυνση",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "address_Num",
      columnDisplayName: "Αριθμός",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "zip",
      columnDisplayName: "Τ.Κ.",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "city_Name",
      columnDisplayName: "Πόλη",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "arrea_Name",
      columnDisplayName: "Περιοχή",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "is_Emporiki",
      columnDisplayName: "Εμπορική",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "Boolean",
    },
    {
      columnName: "is_Citi",
      columnDisplayName: "Citibank",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "Boolean",
    },
    {
      columnName: "description",
      columnDisplayName: "Περιγραφή",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
  ]

  const columns = useMemo(() => {
    console.log("columnData",columnData)
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const closeActionModal = () => {
    setModalEvent({ action: "", selectedRows: [] });
  };

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Τοποθεσίας");
        break;
      case "edit":
        title = t("Επεξεργασία Τοποθεσίας");
        break;
      case "delete":
        title = t("Διαγραφή Τοποθεσίας");
        break;
      default:
        break;
    }
    return title;
  };

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0]
      ? [...[selectedRowsOfTable[0].id]]
      : [];
    console.log(
      "selectedRows",
      selectedRows,
      "selectedRowOfTable",
      selectedRowsOfTable,
      "selectedRowOfTable[0]",
      selectedRowsOfTable[0]
    );
    setModalEvent({ action: event.action, selectedRows: selectedRows });
  };

  useEffect(() => {
    setSelectedRowsOfTable([]);
    getAllPlacesQuery.refetch();
  }, [submitedFilters]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
  };
};
